export default "<i (click)=\"btnClickedHandler($event)\" class=\"fa fa-trash\"></i>\r\n"